const {JustDate} = require('./JustDate')

/**
 * This is a stage 2 backlog model
 */
class Backlog {
    /**
     * @param {string} id
     * @param {string} quoteId
     * @param {string} typeId
     * @param {Date} dateGiven
     * @param {boolean} isChecked
     * @param {string} label
     * @param {number} ordering
     */
    constructor(
        id='', quoteId='', typeId='', dateGiven=new JustDate(),
        isChecked=false, label='', ordering=0,
    ) {
        this.id = id
        this.quote_id = quoteId
        this.type_id = typeId
        this.date_given = dateGiven
        this.is_checked = isChecked
        this.label = label
        this.ordering = ordering
    }

    /**
     * Create a new Backlog from json
     * @param {json} json
     * @return {Backlog}
     */
    static from(json) {
        const backlog = Object.assign(new Backlog(), json)
        backlog.is_checked = !!backlog.is_checked

        if (!(backlog.date_given instanceof Date)) {
            if (backlog.date_given) {
                backlog.date_given = new JustDate(backlog.date_given)
                // backlog.date_given =
                //     new Date(backlog.date_given.getTime() +
                //         60 * 1000 * (new Date()).getTimezoneOffset())
            } else {
                backlog.date_given = new JustDate()
            }
        } else {
            backlog.date_given = new JustDate(backlog.date_given)
            //     new Date(backlog.date_given.getTime() +
            //         60 * 1000 * (new Date()).getTimezoneOffset())
        }

        return backlog
    }

    /**
     * @return {Backlog}
     */
    copy() {
        return Backlog.from(this)
    }

    /**
     * Checks to see if two backlogs are
     *      equalTo eachother
     * @param {Backlog} backlog
     * @return {boolean}
     */
    equalTo(backlog) {
        const isequal = this.id === backlog.id &&
            this.quote_id === backlog.quote_id &&
            this.is_checked === backlog.is_checked &&
            this.label === backlog.label &&
            this.ordering === backlog.ordering

        if (this.is_checked) {
            return isequal &&
                this.date_given.getDate() === backlog.date_given.getDate() &&
                this.date_given.getMonth() === backlog.date_given.getMonth() &&
                this.date_given.getYear() === backlog.date_given.getYear()
        }

        return isequal
    }
}

module.exports = {
    Backlog,
}

